import styled from 'styled-components';

import { 
    FormatListBulletedRounded, 
    BarChart,
    AssistantPhotoRounded, 
    ChevronRight,  
    Message,
    ExitToApp, 
    Search,
    SearchRounded,
    WarningSharp,
    AddRounded,
    Send,
    EmailRounded,
    PhoneAndroidRounded,
    CloudDownloadRounded,
    ArrowBack, 
    Clear, 
    CreditCardRounded,
    EditRounded,
    Done,
    LinearScaleRounded,
    Person,
    ChevronRightRounded,
    NotificationsSharp,
    SecurityRounded,
    Add,
    HomeOutlined,
    RepeatOutlined,
    EmailOutlined,
    BrushOutlined,
    CloudUploadOutlined,
    Edit,
    BlurOn,
    ChevronLeft,
    Link,
    LinkOff,
    PublishRounded,
    ArrowDropDown,
    Title,
    Notes,
    FolderSpecialRounded,
    Image,
    CancelOutlined,
    Mouse,
    AlternateEmail,
    ViewComfyRounded,
    Launch,
    Star,
    StarBorder,
    DashboardRounded,
    ChevronLeftRounded,
    WarningRounded,
    VerifiedUserRounded,
    VideocamRounded,
    BlurOnRounded,
    BlockRounded,
    CategoryRounded,
    ControlPointRounded,
    ExtensionRounded,
    VisibilityRounded,
    VisibilityOffRounded,
    LoopRounded,
    FlagRounded,
    GetAppRounded,
    LocalOfferRounded,
    AutorenewRounded,
    ErrorRounded,
    CheckBoxRounded,
    CheckBoxOutlineBlankRounded,
    EventAvailableRounded,
    LockRounded,
    PublicRounded,
    ForumRounded,
    SettingsRounded,
    FaceOutlined,
    PowerSettingsNew,
    Mic,
    MicOff,
    AttachFile,
    AddAPhoto,
    InsertPhoto,
    PhoneInTalk,
    DragHandle
} from '@material-ui/icons';

import {
    IconAgents,
    IconChannels,
    IconDatabase,
    IconModels,
    IconSettings,
    ScreenShare,
    CameraOn,
    EditNow
} from '../../assets'



import { FaEnvelope, FaFilePdf, FaFileWord, FaFileExcel, FaFileImage, FaFilePowerpoint, FaCloudDownloadAlt, FaLinkedin, FaLinkedinIn } from 'react-icons/fa';


// ICON STYLES


const SenderIcon = styled(Send)`
    && {
        fill: #ffffff;
        font-size:20px;
        transition: all 0.3s;
    }
`

const PublicStyled = styled(PublicRounded)`
    && {
        fill: rgba(26, 59, 103, 1);
        font-size:28px;
        transition: all 0.2s;
    }
`

const LockStyled = styled(LockRounded)`
    && {
        fill: rgba(26, 59, 103, 1);
        font-size:28px;
        transition: all 0.2s;
    }
`


const DragHandleIcon = styled(DragHandle)`
    && {
        fill: rgba(26, 59, 103, 1);
        font-size:15px;
        transition: all 0.2s;
    }
`


const CheckboxSelected = styled(CheckBoxRounded)`
    && {
        fill: rgba(26, 59, 103, 1);
        font-size:28px;
        transition: all 0.2s;
    }
`
const CheckboxUnselected = styled(CheckBoxOutlineBlankRounded)`
    && {
        fill: rgba(26, 59, 103, 0.5);
        font-size:28px;
        transition: all 0.2s;
    }
`


const ErrorStyled = styled(ErrorRounded)`
    && {
        fill: rgba(210, 4, 45, 1);
        font-size:28px;
        transition: all 0.2s;
    }
`


const RenewAuto = styled(AutorenewRounded)`
    && {
        fill: ${props => props.$active ? '#ffffff' : 'rgba(26, 59, 103, 0.5)'};
        font-size:28px;
        transition: all 0.2s;
    }
`

const RenewAutoRed = styled(AutorenewRounded)`
    && {
        fill: rgb(210, 4, 45);
        font-size:20px;
        transition: all 0.2s;
    }
`





const LocalTag = styled(LocalOfferRounded)`
    && {
        fill: ${props => props.$active ? '#ffffff' : 'rgba(26, 59, 103, 0.5)'};
        font-size:20px;
        transition: all 0.2s;
    }
`

const DownloadAnother = styled(GetAppRounded)`
    && {
        fill: #ffffff;
        font-size:20px;
        transition: all 0.2s;
    }
`

const EditName = styled(EditRounded)`
    && {
        fill: rgb(26, 59, 103);
        font-size:15px;
        transition: all 0.2s;
    }
`

const DownloadOther = styled(FaCloudDownloadAlt)`
    && {
        fill: rgb(26, 59, 103);
        font-size:15px;
        transition: all 0.2s;
    }
`


const VisibleOn = styled(VisibilityRounded)`
    && {
        fill: rgb(26, 59, 103);
        font-size:17px;
        transition: all 0.2s;
    }
`

const VisibleOff = styled(VisibilityOffRounded)`
    && {
        fill: rgb(26, 59, 103);
        font-size:17px;
        transition: all 0.2s;
    }
`


const PhoneCallIcon = styled(PhoneInTalk)`
    && {
        fill: rgba(255,255,255,0.8);
        font-size:25px;
        transition: all 0.2s;
    }
`


const AddIconNew = styled(Add)`
    && {
        fill: ${props => props.$active ? 'rgba(26, 59, 103, 1)' : 'rgba(26, 59, 103, 0.5)'};
        font-size:28px;
        transition: all 0.2s;
    }
`

const AddIcon = styled(Add)`
    && {
        fill: rgba(0, 0, 0, 0.7);
        font-size:20px;
        transition: all 0.2s;
    }
`


const AttachFileIcon = styled(AttachFile)`
    && {
        fill: rgba(0, 0, 0, 0.7);
        font-size:20px;
        transition: all 0.2s;
    }
`


const AddAPhotoIcon = styled(InsertPhoto)`
    && {
        fill: rgba(0, 0, 0, 0.7);
        font-size:20px;
        transition: all 0.2s;
    }
`



const SubCategoryIcon = styled(ExtensionRounded)`
    && {
        fill: rgb(26, 59, 103);
        font-size:25px;
        transition: all 0.2s;
    }
`

const CategoryIcon = styled(CategoryRounded)`
    && {
        fill: rgb(26, 59, 103);
        font-size:25px;
        transition: all 0.2s;
    }
`



const VersionLoop = styled(LoopRounded)`
    && {
        fill: #a9a9a9;
        font-size:25px;
        transition: all 0.2s;
    }
`



const DownloadReport = styled(CloudDownloadRounded)`
    && {
        fill: rgb(26, 55, 100);
        font-size:28px;
        transition: all 0.2s;
    }
`

const CategoryIconNone = styled(CategoryRounded)`
    && {
        fill: rgb(26, 55, 100);
        font-size:22px;
        transition: all 0.2s;
    }
`


const VersionRounded = styled(FlagRounded)`
    && {
        fill: rgb(26, 55, 100);
        font-size:22px;
        transition: all 0.2s;
    }
`



const TagsNav = styled(CategoryRounded)`
    && {
        fill: ${props => props.$active ?  'rgba(255,255,255,1)' : 'rgba(255,255,255,0.5)'};
        width: 23px;
        height: 23px;
        transition: all 0.2s;
    }
`

const SafeGray = styled(BlockRounded)`
     && {
        fill: #a9a9a9;
        width: 20px;
        height: 20px;
        transition: all 0.2s;
    }
`

const AdjustmentStyled = styled(BlurOnRounded)`
     && {
        fill: #000000;
        width: 20px;
        height: 20px;
        transition: all 0.2s;
    }
`


const WarningIcon = styled(WarningRounded)`
    && {
        fill: rgb(236, 120, 125);
        width: 30px;
        height: 30px;
        transition: all 0.2s;
    }
`

const PassedIcon = styled(VerifiedUserRounded)`
    && {
        fill:rgb(88, 192, 164);
        width: 30px;
        height: 30px;
        transition: all 0.2s;
    }
`

const FaEnvelopeIcon = styled(FaEnvelope)`
    && {
        fill: #000000;
        width: 22px;
        height: 22px;
        transition: all 0.2s;
    }
`

const FaLinkedinIcon = styled(FaLinkedin)`
    && {
        fill: #000000;
        width: 25px;
        height: 25px;
        transition: all 0.2s;
    }
`

const FaLinkedinInIcon = styled(FaLinkedinIn)`
    && {
        fill: #000000;
        width: 25px;
        height: 25px;
        transition: all 0.2s;
    }
`

const PDFIcon = styled(FaFilePdf)`
    && {
        fill: #000000;
        width: 25px;
        height: 25px;
        transition: all 0.2s;
    }
`

const WordIcon = styled(FaFileWord)`
    && {
        fill: #000000;
        width: 25px;
        height: 25px;
        transition: all 0.2s;
    }
`


const ChevronRightRoundedStyled = styled(ChevronRightRounded)`
    && {
        fill: rgb(26, 55, 100);
        width: 25px;
        height: 25px;
        transition: all 0.2s;
    }
`

const ChevronRightRoundedStyledWhite = styled(ChevronRightRounded)`
    && {
        fill: #ffffff;
        width: 25px;
        height: 25px;
        transition: all 0.2s;
        margin-bottom: 5px;
    }
`

const MicIcon = styled(Mic)`
    && {
        fill: ${props => props.videoMode ? 'rgba(255, 255, 255,1)' : 'rgba(0, 0, 0,1)'};
        font-size:20px;
        transition: all 0.2s;
    }
`


const MicOffIcon = styled(MicOff)`
    && {
        fill: ${props => props.videoMode ? 'rgba(255, 255, 255,1)' : 'rgba(0, 0, 0,1)'};
        font-size:20px;
        transition: all 0.2s;
    }
`


const ChevronDownRotate = styled(ChevronRightRounded)`
    && {
        fill: rgb(26, 55, 100);
        width: 25px;
        height: 25px;
        transition: all 0.2s;
        transform: rotate(${props => props.show ? '270deg' : '90deg'});
    }
`


const ExcelIcon = styled(FaFileExcel)`
    && {
        fill: #000000;
        width: 25px;
        height: 25px;
        transition: all 0.2s;
    }
`


const ImageIcon = styled(FaFileImage)`
    && {
        fill: #000000;
        width: 25px;
        height: 25px;
        transition: all 0.2s;
    }
`


const PowerpointIcon = styled(FaFilePowerpoint)`
    && {
        fill: #000000;
        width: 25px;
        height: 25px;
        transition: all 0.2s;
    }
`


const TitleStyled = styled(Title)`
    && {
        fill: #000000;
        width: 25px;
        height: 25px;
        transition: all 0.2s;
    }
`


const NotesStyled = styled(Notes)`
    && {
        fill: #000000;
        width: 25px;
        height: 25px;
        transition: all 0.2s;
    }
`

const ImageStyled = styled(Image)`
    && {
        fill: #000000;
        width: 25px;
        height: 25px;
        transition: all 0.2s;
    }
`

const MouseStyled = styled(Mouse)`
    && {
        fill: #000000;
        width: 25px;
        height: 25px;
        transition: all 0.2s;
    }
`


const BarChartStyled = styled(BarChart)`
    && {
        fill: #ffffff;
        width: 25px;
        height: 25px;
        transition: all 0.2s;
    }
`


const PublishedStyled = styled(PublishRounded)`
    && {
        fill: #ffffff;
        width: 25px;
        height: 25px;
        transition: all 0.2s;
    }
`


const NotificationsNoneOutlined = styled(NotificationsSharp)`
    && {
        fill: ${props => props.focus ? '#ffffff' :  '#d5d5d5'};
        width: 25px;
        height: 25px;
        transition: all 0.2s;

    }
`




const PublishedBlueStyled = styled(PublishRounded)`
    && {
        fill: rgb(0, 146, 255);
        width: 25px;
        height: 25px;
        transition: all 0.2s;
    }
`


const ArrowDropDownStyled = styled(ArrowDropDown)`
    && {
        fill: #000000;
        width: 25px;
        height: 25px;
        transition: all 0.2s;
    }
`

const LinearScaleRoundedFull = styled(LinearScaleRounded)`
    && {
        fill: #d5d5d5;
        width: 25px;
        height: 25px;
        transition: all 0.2s;
    }
`


const HomeAgents = styled(IconAgents)`
    && {
        fill: #000000;
        width: 23px;
        height: 23px;
        transition: all 0.2s;
    }
`

const CommunicationAdaptors = styled(IconChannels)`
    && {
        fill: ${props => props.$active ?  'rgba(0,0,0,1)' : 'rgba(0,0,0,0.5)'};
        width: 23px;
        height: 23px;
        transition: all 0.2s;
    }
`

const HomeFace = styled(FaceOutlined)`
    && {
        fill: ${props => props.$active ?  'rgba(0,0,0,1)' : 'rgba(0,0,0,0.5)'};
        width: 23px;
        height: 23px;
        transition: all 0.2s;
    }
`

const EmailFace = styled(EmailRounded)`
    && {
        fill: ${props => props.$active ?  'rgba(0,0,0,1)' : 'rgba(0,0,0,0.5)'};
        width: 23px;
        height: 23px;
        transition: all 0.2s;
    }
`

const PhoneFace = styled(PhoneAndroidRounded)`
    && {
        fill: ${props => props.$active ?  'rgba(0,0,0,1)' : 'rgba(0,0,0,0.5)'};
        width: 23px;
        height: 23px;
        transition: all 0.2s;
    }
`


const ModelsAdaptors = styled(IconModels)`
    && {
        fill: ${props => props.$active ?  'rgba(0,0,0,1)' : 'rgba(0,0,0,0.7)'};
        width: 23px;
        height: 23px;
        transition: all 0.2s;
    }
`


const ScreenShareIcon = styled(ScreenShare)`
    && {
        fill: ${props => props.$active ?  'rgba(0,0,0,1)' : 'rgba(0,0,0,0.7)'};
        width: 30px;
        height: 30px;
        transition: all 0.2s;
    }
`




const CameraOnIcon = styled(CameraOn)`
    && {
        fill: ${props => props.$active ?  'rgba(0,0,0,1)' : 'rgba(0,0,0,0.7)'};
        width: 30px;
        height: 30px;
        transition: all 0.2s;
    }
`



const EditNowIcon = styled(EditNow)`
    && {
        fill: ${props => props.$active ?  'rgba(0,0,0,1)' : 'rgba(0,0,0,0.7)'};
        width: 20px;
        height: 20px;
        transition: all 0.2s;
    }
`




const StorageAdaptors = styled(IconDatabase)`
    && {
        fill: ${props => props.$active ?  'rgba(0,0,0,1)' : 'rgba(0,0,0,0.7)'};
        width: 23px;
        height: 23px;
        transition: all 0.2s;
    }
`

const SettingsIcon = styled(IconSettings)`
    && {
        fill: ${props => props.$active ?  'rgba(0,0,0,1)' : 'rgba(0,0,0,0.7)'};
        width: 23px;
        height: 23px;
        transition: all 0.2s;
    }
`


const PowerOn = styled(PowerSettingsNew)`
    && {
        fill: ${props => props.$active ?  'rgba(0,0,0,1)' : 'rgba(0,0,0,0.7)'};
        width: 23px;
        height: 23px;
        transition: all 0.2s;
    }
`


const DashboardWhite = styled(DashboardRounded)`
    && {
        fill: ${props => props.$active ?  'rgba(255,255,255,1)' : 'rgba(255,255,255,0.5)'};
        width: 23px;
        height: 23px;
        transition: all 0.2s;
    }
`



const TimelineStyled = styled(EventAvailableRounded)`
    && {
        fill: ${props => props.$active ?  'rgba(255,255,255,1)' : 'rgba(255,255,255,0.5)'};
        width: 23px;
        height: 23px;
        transition: all 0.2s;
    }
`




const VerifiedUserRoundedWhite = styled(VerifiedUserRounded)`
    && {
        fill: ${props => props.$active ?  'rgba(255,255,255,1)' : 'rgba(255,255,255,0.5)'};
        width: 23px;
        height: 23px;
        transition: all 0.2s;
    }
`



const FolderSpecialRoundedWhite = styled(FolderSpecialRounded)`
    && {
        fill: ${props => props.$active ?  'rgba(255,255,255,1)' : 'rgba(255,255,255,0.5)'};
        width: 23px;
        height: 23px;
        transition: all 0.2s;
    }
`





const LinkNewStyled = styled(Link)`
    && {
        fill: #ffffff;
        width: 20px;
        height: 20px;
        transition: all 0.2s; 
    }
`

const LinkNewOffStyled = styled(LinkOff)`
    && {
        fill: #a9a9a9;
        width: 20px;
        height: 20px;
        transition: all 0.2s; 
    }
`


const AlternateEmailStyled = styled(AlternateEmail)`
    && {
        fill: #000000;
        width: 20px;
        height: 20px;
        transition: all 0.2s; 
    }
`

const ViewComfyRoundedStyled = styled(ViewComfyRounded)`
    && {
        fill: #000000;
        width: 20px;
        height: 20px;
        transition: all 0.2s; 
    }
`

const LaunchStyled = styled(Launch)`
    && {
        fill: #000000;
        width: 20px;
        height: 20px;
        transition: all 0.2s; 
    }
`


const LinkStyled = styled(Link)`
    && {
        fill: #ffffff;
        width: 25px;
        height: 25px;
        transition: all 0.2s; 
    }
`

const LinkOffStyled = styled(LinkOff)`
    && {
        fill: #ffffff;
        width: 25px;
        height: 25px;
        transition: all 0.2s; 
    }
`


const SearchStyled = styled(Search)`
    && {
        fill: #ffffff;
        width: 25px;
        height: 25px;
        transition: all 0.2s; 
    }
`

const SearchStyledChat = styled(SearchRounded)`
    && {
        fill: rgba(0,0,0,0.7)
        width: 25px;
        height: 25px;
        transition: all 0.2s; 
    }
`

const SettingStyledChat = styled(SettingsRounded)`
    && {
        fill: rgba(0,0,0,0.7)
        width: 25px;
        height: 25px;
        transition: all 0.2s; 
    }
`

const VideoStyledChat = styled(VideocamRounded)`
    && {
        fill: rgba(0,0,0,0.7)
        width: 25px;
        height: 25px;
        transition: all 0.2s; 
    }
`

const ChatStyledChat = styled(ForumRounded)`
    && {
        fill: rgba(0,0,0,0.7)
        width: 25px;
        height: 25px;
        transition: all 0.2s; 
    }
`

const AssistantStyled = styled(AssistantPhotoRounded)`
    && {
        fill: #090909;
        font-size:20px;
    }
`

const BlurOnStyled = styled(BlurOn)`
    && {
        fill: #090909;
        font-size:20px;
    }
`

const HomeStyled = styled(HomeOutlined)`
    && {
        fill: #ffffff;
        font-size:20px;
    }
`

const MessageStyled = styled(Message)`
    && {
        fill: #ffffff;
        font-size:20px;
        transition: all 0.3s;
    }
`

const MessageStyledWhite = styled(Message)`
    && {
        fill: #FFFFFF;
        font-size:20px;
    }
`

const UploadWhite = styled(CloudUploadOutlined)`
    && {
        fill: #FFFFFF;
        font-size:40px;
    }
`

const EditWhite = styled(Edit)`
    && {
        fill: #FFFFFF;
        font-size:40px;
    }
`

const EditBlue = styled(EditRounded)`
    && {
        fill: blue;
        font-size:25px;
        transition: all 0.2s;
    }
`

const EditOtherBlue = styled(EditRounded)`
    && {
        fill: rgb(0, 146, 255);
        font-size:20px;
        transition: all 0.2s;
    }
`

const ChevronLeftStyledFinal = styled(ChevronLeftRounded)`
    && {
        fill: rgba(26, 55, 100, 0.5);
        font-size:30px;
        transition: all 0.2s;
        transform: scale(1.0);

        &:hover {
            fill: rgba(26, 55, 100,1);
            transform: scale(1.2);
        }
    }
`

const ChevronLeftBlueStyled = styled(ArrowBack)`
    && {
        fill: blue;
        font-size:15px;
        transition: all 0.2s;
    }
`

const ExitToAppStyled = styled(ExitToApp)`
    && {
        fill: #090909;
        font-size:20px;
    }
`

const ChevronRightStyled = styled(ChevronRight)`
    && {
        fill: #090909;
        font-size:40px;
    }
`

const ChevronLeftStyled = styled(ChevronLeft)`
    && {
        fill: #090909;
        font-size:40px;
    }
`

const ChevronRightBlueStyled = styled(ChevronRight)`
    && {
        fill: rgb(0, 146, 255);
        font-size:40px;
    }
`




const FormatListBulletedRoundedStyled = styled(FormatListBulletedRounded)`
    && {
        fill: #ffffff;
        width: 25px;
        height: 25px;
        transition: all 0.2s;
        
    }
`

const ErrorSymbol = styled(WarningSharp)`
    && {
        fill: red;
        font-size: 20px;
        transition: all 0.5s;
    }
`

const WarningSymbolStyled = styled(WarningSharp)`
    && {
        fill: rgb(255, 127, 127);
        font-size: 15px;
        transition: all 0.5s;
        margin-left:10px;
    }
`

const SendStyled = styled(Send)`
    && {
        fill: #ffffff;
        font-size:25px;
    }
`


const EmailStyled = styled(EmailOutlined)`
    && {
        fill: #000000;
        font-size:25px;
    }
`

const BrushStyled = styled(BrushOutlined)`
    && {
        fill: #ffffff;
        font-size:25px;
    }
`


const RepeatStyled = styled(RepeatOutlined)`
    && {
        fill: #ffffff;
        font-size:25px;
    }
`





const CloudDownloadRoundedStyled = styled(CloudDownloadRounded)`
    && {
        fill: #ffffff;
        font-size:20px;
        transition: all 0.2s;
    }
`


const CreditCardRoundedStyled = styled(CreditCardRounded)`
    && {
        fill: ${props => props.active === 'true' ? `#ffffff` : `#090909`};
        font-size:25px;
        transition: all 0.2s;
    }
`


const ChevronRightStyledSmall = styled(ChevronRight)`
    && {
        fill: #090909;
        font-size:20px;
    }
`

const ChevronRightStyledSmallWhite = styled(ChevronRightRounded)`
    && {
        fill: #ffffff;
        font-size:23px;
    }
`

const ChevronLeftStyledSmallWhite = styled(ChevronLeftRounded)`
    && {
        fill: #ffffff;
        font-size:23px;
        margin-right:2px;
    }
`

const ChevronRightStyledSmallBlueSmall = styled(ChevronRight)`
    && {
        fill: #316AB7;
        font-size:23px;
        margin-left:2px;
    }
`


const ChevronRightStyledSmallBlue = styled(ChevronRightRounded)`
    && {
        fill: rgb(26, 55, 100);
        font-size:23px;
        transition: all 0.5s;
        transform: scale(1.0);
    }
`


const ChevronLeftStyledSmallBlue = styled(ChevronLeftRounded)`
    && {
        fill: rgb(26, 55, 100);
        font-size:23px;
        transition: all 0.5s;
        transform: scale(1.0);
    }
`

const AddStyledWhite = styled(Add)`
    && {
        fill: #ffffff;
        font-size:25px;
    }
`

const AddStyledLightWhite = styled(AddRounded)`
    && {
        fill: #ffffff;
        font-size:23px;
    }
`


const CancelFullStyled = styled(CancelOutlined)`
    && {
        fill: #ffffff;
        font-size:20px;
        transition: all 0.2s;
    }
`

const CancelOutlinedStyled = styled(Clear)`
    && {
        fill: #ffffff;
        font-size:20px;
        transition: all 0.2s;
    }
`

const CancelOutlinedStyledBlack = styled(Clear)`
    && {
        fill: rgba(0,0,0,0.5);
        font-size:20px;
        transition: all 0.2s;
    }
`

const CancelOutlinedStyledMini = styled(Clear)`
    && {
        fill: #FF7F7F;
        font-size:15px;
        transition: all 0.2s;
    }
`

const CancelOutlinedStyledLarge = styled(Clear)`
    && {
        fill: #FF7F7F;
        font-size:30px;
        transition: all 0.2s;
    }
`

const CancelOutlinedStyledRed = styled(Clear)`
    && {
        fill: #FF7F7F;
        font-size:20px;
        transition: all 0.2s;
    }
`



const CancelOutlinedStyledDark = styled(Clear)`
    && {
        fill: #090909;
        opacity:0.5;
        font-size:20px;
        transition: all 0.2s;

        &:hover {
            opacity:0.9;
        }

        &:active {
            opacity:1.0;
        }
    }
`

const ArrowBackStyled = styled(ArrowBack)`
    && {
        fill: #000000;
        font-size:25px;
        transition: all 0.2s;
        transform: scale(1.01);

        &:hover {
            transform: scale(1.2);
        }

        &:active {
            transform: scale(0.98);
        }
    }
`


const ArrowBackStyledMini = styled(ArrowBack)`
    && {
        fill: rgba(0,0,0,0.5);
        font-size:15px;
        transition: all 0.2s;
        transform: scale(1.01);

        &:hover {
            transform: scale(1.2);
        }

        &:active {
            transform: scale(0.98);
        }
    }
`


const DoneStyled = styled(Done)`
    && {
        fill: green;
        font-size:20px;
        transition: all 0.2s;
    }
`

const DoneWhiteStyled = styled(Done)`
    && {
        fill: #FFFFFF;
        font-size:20px;
        transition: all 0.2s;
    }
`

const DoneWhiteSmallStyled = styled(Done)`
    && {
        fill: #FFFFFF;
        font-size:15px;
        transition: all 0.2s;
    }
`

const DoneSmallStyled = styled(Done)`
    && {
        fill: rgb(0,205,122);
        font-size:15px;
        transition: all 0.2s;
        margin-left:10px;
    }
`


const DoneSmallStyledGrey = styled(Done)`
    && {
        fill: rgb(108, 135, 174);
        font-size:15px;
        transition: all 0.2s;
        margin-left:10px;
    }
`


const ClearStyledRed = styled(Clear)`
    && {
        fill: red;
        font-size:20px;
        transition: all 0.2s;
    }
`


const PersonStyled = styled(Person)`
    && {
        fill: ${props => props.active === 'true' ? `#ffffff` : `#090909`};
        font-size:25px;
        transition: all 0.2s;
    }
`


const SecurityRoundedStyled = styled(SecurityRounded)`
    && {
        fill: ${props => props.active === 'true' ? `#ffffff` : `#090909`};
        font-size:25px;
        transition: all 0.2s;
    }
`



const StarStyled = styled(Star)`
    && {
        fill: #1676F3;
        font-size:30px;
        cursor:pointer;

        &:hover {
            opacity:0.9;
        }
    }
`


const StarBorderStyled = styled(StarBorder)`
    && {
        fill: #1676F3;
        font-size:30px;
        cursor:pointer;

        &:hover {
            opacity:0.9;
        }
    }
`





// EXPORTS

export {
    FormatListBulletedRoundedStyled,
    PDFIcon,
    WordIcon,
    ExcelIcon,
    ImageIcon,
    PowerpointIcon,
    ChevronRightStyled,
    ExitToAppStyled,
    MessageStyled,
    AssistantStyled,
    SearchStyled,
    BarChartStyled,
    ErrorSymbol,
    SendStyled,
    HomeStyled,
    ChevronRightStyledSmall,
    LinearScaleRoundedFull,
    CloudDownloadRoundedStyled,
    CreditCardRoundedStyled,
    CancelOutlinedStyled,
    CancelOutlinedStyledRed,
    ChevronRightStyledSmallBlue,
    ArrowBackStyled,
    MessageStyledWhite,
    DoneStyled,
    ClearStyledRed,
    PersonStyled,
    SecurityRoundedStyled,
    AddStyledWhite,
    EmailStyled,
    RepeatStyled,
    StarStyled,
    ChevronRightStyledSmallWhite,
    StarBorderStyled,
    VerifiedUserRoundedWhite,
    BrushStyled,
    UploadWhite,
    EditBlue,
    EditWhite,
    CancelOutlinedStyledDark,
    CancelOutlinedStyledMini,
    BlurOnStyled,
    ChevronRightBlueStyled,
    NotificationsNoneOutlined,
    ChevronLeftStyled,
    LinkStyled,
    LinkOffStyled,
    PublishedStyled,
    PublishedBlueStyled,
    DoneWhiteStyled,
    ChevronLeftBlueStyled,
    CancelOutlinedStyledLarge,
    ArrowDropDownStyled,
    TitleStyled,
    WarningIcon,
    NotesStyled,
    CancelFullStyled,
    EmailFace,
    MouseStyled,
    ImageStyled,
    AddStyledLightWhite,
    PassedIcon,
    EditOtherBlue,
    LinkNewStyled,
    AdjustmentStyled,
    DashboardWhite,
    ChevronDownRotate,
    LinkNewOffStyled,
    AlternateEmailStyled,
    ViewComfyRoundedStyled,
    LaunchStyled,
    FolderSpecialRoundedWhite,
    DoneWhiteSmallStyled,
    ScreenShareIcon,
    WarningSymbolStyled,
    DoneSmallStyled,
    ChevronLeftStyledFinal,
    ChevronRightRoundedStyled,
    ChevronRightRoundedStyledWhite,
    SafeGray,
    TagsNav,
    AddIcon,
    CategoryIcon,
    SubCategoryIcon,
    VisibleOn,
    VisibleOff,
    EditName,
    ArrowBackStyledMini,
    CategoryIconNone,
    VersionLoop,
    DownloadReport,
    VersionRounded,
    DownloadOther,
    DownloadAnother,
    LocalTag,
    AddIconNew,
    RenewAuto,
    ErrorStyled,
    RenewAutoRed,
    CheckboxSelected,
    CheckboxUnselected,
    TimelineStyled,
    LockStyled,
    PublicStyled,
    DoneSmallStyledGrey,
    HomeAgents,
    CommunicationAdaptors,
    HomeFace,
    StorageAdaptors,
    PowerOn,
    SettingsIcon,
    PhoneFace,
    ChevronRightStyledSmallBlueSmall,
    ChevronLeftStyledSmallBlue,
    ChatStyledChat,
    VideoStyledChat,
    SettingStyledChat,
    SearchStyledChat,
    MicIcon,
    MicOffIcon,
    SenderIcon,
    AttachFileIcon,
    AddAPhotoIcon,
    PhoneCallIcon,
    DragHandleIcon,
    ChevronLeftStyledSmallWhite,
    ModelsAdaptors,
    CameraOnIcon,
    EditNowIcon,
    CancelOutlinedStyledBlack,
    FaLinkedinIcon,
    FaLinkedinInIcon,
    FaEnvelopeIcon
}